import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { map, exhaustMap, catchError } from 'rxjs/operators';

import * as AnalysisResultsTextActions from '../actions/analysis-results-text.actions';
import { AnalysisResultsTextService } from '../services/analysis-results-text.service';
import { AnalysisResultsTextCommon } from '@sleipai/sleip-models';
import { of } from 'rxjs';

@Injectable()
export class AnalysisResultsTextEffects implements OnInitEffects {
  loadAnalysisResultsTextStore$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AnalysisResultsTextActions.loadAnalysisResultsTexts),
      exhaustMap(() =>
        this.analysisResultsTextService.loadAnalysisResultTexts().pipe(
          map((analysisResultsTexts: AnalysisResultsTextCommon[]) =>
            AnalysisResultsTextActions.loadAnalysisResultsTextsSuccess({
              data: analysisResultsTexts,
            })
          )
        )
      ),
      catchError((error) =>
        of(
          AnalysisResultsTextActions.loadAnalysisResultsTextsFailure({
            error: error,
          })
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private analysisResultsTextService: AnalysisResultsTextService
  ) {}

  ngrxOnInitEffects() {
    return AnalysisResultsTextActions.loadAnalysisResultsTexts();
  }
}
